<template>
  <v-flex class="pa-3" style="background: #333;" xs12>
    <v-simple-table style="border: 1px solid #E5E5E5" dense>
      <template v-slot:default>
        <thead>
          <tr>
            <td class="font-weight-bold">Assunto</td>
            <td class="font-weight-bold">Lida</td>
            <td class="font-weight-bold">Hora</td>
          </tr>
        </thead>
        <tbody>
          <tr
            :style="
              `cursor: pointer; background: ${i % 2 === 0 ? '#f2f2f2' : '#fff'}`
            "
            v-for="(item, i) in get_notifications.docs"
            :key="item.id"
          >
            <td @click="abre_modal_view_notification(item)">
              {{ item.title }}
            </td>
            <td
              v-if="item.readed"
              class="font-weight-bold"
              @click="abre_modal_view_notification(item)"
            >
              lida
            </td>
            <td
              v-else
              class="font-weight-bold"
              @click="abre_modal_view_notification(item)"
            >
              não lida
            </td>
            <td
              class="font-weight-bold"
              @click="abre_modal_view_notification(item)"
            >
              {{ $moment(item.created_at).format("DD/MM/YYYY [às] HH:mm") }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["get_notifications"])
  },
  methods: {
    ...mapActions(["abre_modal_view_notification", "createConfirmAction"]),
    setMarcado(event, item) {
      console.log("event", event);
      // this.add_notification_marcado(item)
    }
  }
};
</script>
